import { Maybe } from 'maybe-not';
import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';

export default function printWindow() {
    sendMessage('printWindow', Maybe.nothing<string>());
}
